import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom, take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/services/auth.service';
import { SubdomainService } from '../../../core/services/subdomain.service';
import { auth as AuthGen } from '@valvur/shared-grpc';

@Injectable({ providedIn: 'root' })
export class PatrolUserService {
  #http = inject(HttpClient);
  #authService = inject(AuthService);
  #subdomain = inject(SubdomainService);

  patrolUser = computed(() => this.#patrolQuery.data());

  /** True until the first profile response is available (including while disabled). */
  isPending = computed(() => this.#patrolQuery.isPending());

  #patrolQuery = injectQuery(() => ({
    queryKey: ['patrol', 'profile'],
    retry: 1,
    queryFn: () =>
      lastValueFrom(
        this.#http
          .get<AuthGen.User>(`${environment.baseUrl}/user/patrol`)
          .pipe(take(1)),
      ),
    enabled:
      this.#authService.isAuthenticated() &&
      this.#subdomain.isPatrolSubdomain(),
  }));

  refetch(): Promise<unknown> {
    return this.#patrolQuery.refetch();
  }
}
